import { render, staticRenderFns } from "./customer-group.vue?vue&type=template&id=6ae3292f"
import script from "./customer-group.vue?vue&type=script&lang=js"
export * from "./customer-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports